var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('y-upload',_vm._b({staticClass:"cell-upload",attrs:{"action":"","limit":1},on:{"on-success":_vm.handleUpload,"on-remove":_vm.handleUpload}},'y-upload',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }